import { render, staticRenderFns } from "./NumbersWidget.vue?vue&type=template&id=d38e0b6a&scoped=true"
import script from "./NumbersWidget.vue?vue&type=script&lang=js"
export * from "./NumbersWidget.vue?vue&type=script&lang=js"
import style0 from "./NumbersWidget.vue?vue&type=style&index=0&id=d38e0b6a&prod&scoped=true&lang=scss"
import style1 from "./NumbersWidget.vue?vue&type=style&index=1&id=d38e0b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38e0b6a",
  null
  
)

export default component.exports